module.exports = __webpack_public_path__ + "assets/images/school-header-old.svg?v=276bcc7e";